import { render, staticRenderFns } from "./DataPrinter.vue?vue&type=template&id=062a9049&scoped=true&"
import script from "./DataPrinter.vue?vue&type=script&lang=ts&"
export * from "./DataPrinter.vue?vue&type=script&lang=ts&"
import style0 from "./DataPrinter.vue?vue&type=style&index=0&id=062a9049&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062a9049",
  null
  
)

export default component.exports